import { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import Footer from "../../components/Footer"
import Header from "../../components/Header"
import PayChannelItem from "../../components/PayChannelItem"
import CurrencyItem from "../../components/CurrencyItem"
import PayMoneyItem from "../../components/PayMoneyItem"
import UserInfoPanel from "../../components/UserInfoPanel"
import useAPI from "../../hooks/common/useAPI"
import useSDK from "../../hooks/data/useSDK"
import Padding from "../../components/Padding"
import { Toast, Tabs, NoticeBar } from "antd-mobile"
import InnerHeader from "../../components/InnerHeader"
import KeFu from "../../components/KeFu"
import upSvg from '../../svg/up.svg'
import "./index.less"
import PayCny from "../../components/PayCny"

export default () => {


    const { request } = useAPI()

    const [userinfo, setUserinfo] = useState()

    const { getAppid, canExit, exit } = useSDK()
    const getUserinfo = async () => {

        let rs = await request("/user/info")
        if (rs?.result === true) {
            setUserinfo(rs?.data)
            return true;
        } else {
            Toast.show(rs?.message)
            return false;
        }

    }

    useEffect(() => {
        getUserinfo();
    }, [])








    const [selectedPayChannel, setSelectedPayChannel] = useState()
    const [selectedCny, setSelectedCny] = useState()

    // const paychanels = [
    //     {
    //         id: "1",
    //         iocn: require("../../icons/wechat.png"),
    //         title: "微付支付",
    //         desc: "推荐使用微信支付付款",
    //         disabled: 1
    //     },
    //     {
    //         id: "2",
    //         iocn: require("../../icons/alipay.png"),
    //         title: "支付宝",
    //         desc: "安全快捷的支付方式",
    //         disabled: 0
    //     },
    // ]

    const [paychannels, setPaychannes] = useState()
    const [cnyList, setCnyList] = useState()
    const [pay, setPay] = useState()

    const getPayChannels = async () => {
        let rs = await request("/pay/channels3", {})

        if (rs?.result === true) {

            setCnyList(rs?.data)
            let item = rs?.data?.[0]
            let list = item?.list
            setSelectedCny(item?.id);



            setPaychannes(list)
            let pay = list?.find(t => t.is_default === 1)
            setSelectedPayChannel(pay?.id);
            setPay({icon: pay.icon, name:pay.name})

        } else {
            Toast.show(rs?.message)
        }
    }

    const [notice, setNotice] = useState()
    const getNotice = async () => {
        let rs = await request("/app/mallNote", {})

        if (rs?.result === true) {

            setNotice(rs?.data?.mallNote)

        }
    }

    const clickCny = (key) => {
        let id = Number(key)
        let item = cnyList?.find(t => t.id === id)
        let list = item?.list
        setSelectedCny(item?.id);



        setPaychannes(list)
        let pay = list?.find(t => t.is_default === 1)
        if (!pay) {
            pay = list?.[0]
        }
        setSelectedPayChannel(pay?.id);
        // getMoneys()
    }


    useEffect(() => {
        getPayChannels()
        getNotice()
    }, [])



    const [moneys, setMoneys] = useState()
    const [showPaylist, setShowPaylist] = useState(false)
    const getMoneys = async () => {
        let rs = await request("/pay/moneys", { pay_channel_id: selectedPayChannel })
        if (rs?.result === true) {
            setMoneys(rs?.data)
        } else {
            Toast.show(rs?.message)
        }
    }

    useEffect(() => {
        if (!selectedPayChannel) return;
        getMoneys();
    }, [selectedPayChannel])




    return <div className="big-c">
        
    <Padding />
        {/* <Header /> */}
        {/* <InnerHeader title={`充值中心`} onBack={exit} />  */}

        <UserInfoPanel

            onBack={exit}
            onRefresh={async () => {
                let rs = await getUserinfo();
                if (rs) Toast.show('信息已更新')
            }} name={userinfo?.username} coins={(userinfo?.money / 100).toFixed(2)} face_img={<PayCny name={cnyList?.[0]?.name} />} />


        





        


        <div style={{color:"#000D20", display:"flex", justifyContent:"center", flexDirection:"column", alignItems:"center", position:"absolute", width:"100%", boxSizing:"border-box", background:"", paddingTop: notice?'0.5rem':"0.18rem" }}>
            <div style={{fontFamily:"Source Han Sans CN, Source Han Sans CN",fontStyle:"normal", fontSize:"0.14rem", fontWeight:"400",color:"#777E90"}}>支付方式</div>
            <div style={{ marginTop: "0.15rem", display:"flex", justifyContent:"center"}} onClick={()=>setShowPaylist(!showPaylist)}>
                            <div className="cny1">
                                {pay?<div style={{display:"flex", alignItems:"center"}}><img src={pay?.icon} style={{ width: "0.3rem", height: "0.3rem" }} /></div>:""}
                                <div style={{width:"1.5rem"}}>{pay?.name}</div>
                                {/* {showPaylist?<div style={{transform:"rotate(90deg)", width:""}}><img src={upSvg} style={{width:"0.3rem"}} /></div>:<div style={{transform:"rotate(270deg)", width:""}}><img src={upSvg} style={{width:"0.3rem"}} /></div>} */}
                                {showPaylist?<div style={{ display:"flex",alignItems:"center", fontSize:"0.13rem", color:"#999"}}>更多支付&nbsp;<img src={upSvg} style={{transform:"rotate(90deg)",width:"0.2rem"}} /></div>:
                                <div style={{display:"flex",alignItems:"center", fontSize:"0.13rem", }}>更多支付&nbsp;<img src={upSvg} style={{transform:"rotate(270deg)",width:"0.2rem"}} /></div>}
                            </div>
            </div>
            {showPaylist?<div className="big-box">
                {paychannels?.map(function (t) {
                    return <>
                        <div className="pay-list"  onClick={()=>{
                            setShowPaylist(!showPaylist)
                            setPay({icon:t.icon, name:t.name})
                            setSelectedPayChannel(t.id)
                        }}>
                            <div><img src={t.icon} style={{ width: "0.3rem", height: "0.3rem" }} /></div>
                            <div  style={{marginLeft:"0.2rem"}}>{t.name}</div>
                        </div>
                        {/* <PayChannelItem key={t.id} icon={t.icon}
                            title={t.name}
                            type={t.big_paytype}
                            desc={t.desc}
                            checked={selectedPayChannel === t.id}
                            onClick={() => {
                                setSelectedPayChannel(t.id)
                            }}
                            disabled={t.enabled === 0}
                        /> */}

                       
                    </>

                })}
            </div>:''}
        </div>
    <div style={{ background: "#fff" , padding:"0 0.31rem",  boxSizing:"border-box"}}>
        {notice && <NoticeBar content={notice}
            color='alert' speed={30} className='notice-bar' style={{ color: "red", fontWeight: "bold", fontFamily: "cursive" }} />}

<div style={{height:"1rem"}}></div>
        {moneys?.map(t => {
            return <div key={t.id}>

                <div style={{fontFamily:"Source Han Sans CN, Source Han Sans CN",fontStyle:"normal", fontSize:"0.14rem", fontWeight:"400", color:"#777E90", display:"flex", justifyContent:"center", marginTop:"0.2rem" }}>
                    <div>{t.name}</div>
                </div>


                <div style={{ width: "100%",  display: 'flex', flexDirection: "row", flexWrap: "wrap", alignItems: 'center', justifyContent: "space-around" }}>
                    {t?.list?.map(s => {
                        // s.pay_money = 217
                        // s.money = 230
                        return <>
                            <PayMoneyItem key={s.id} desc={s.desc}
                                money={(s.pay_money/ 100).toFixed(2)}
                                coin={`${(s.money / 100).toFixed(2)}`}
                                yh = {((s.money - s.pay_money ) / 100).toFixed(2)}
                                onClick={() => {
                                    window.location.href =
                                        `#/order_confirm?money_id=${s.id}&pay_channel_id=${selectedPayChannel}&money=${s.money}&pay_money=${s.pay_money}&paytype=${paychannels.find(t => t.id === selectedPayChannel)?.name}&cny=${cnyList?.[0]?.name}`
                                }}

                            />

                        </>
                    })}

                    <div style={{ width: "1rem" }}></div>
                    <div style={{ width: "1rem" }}></div>





                </div>
            </div>
        })}
        {/* {(userinfo && !userinfo?.phone) && <div style={{ width: "96%", margin: "auto", marginTop: "0.1rem", display: 'flex', flexDirection: "row", justifyContent: "center" }}>
            <div style={{ backgroundColor: "#ab731f", padding: "0.1rem 0.3rem", lineHeight: "0.16rem", borderRadius: "1rem", fontWeight: 'bold', fontSize: "0.12rem", color:"#fff" }}
                onClick={() => window.location.href = "#/bindphone"}
            >綁定手機號，立即贈送5元。<span style={{ fontSize: "0.16rem" }}>👆</span></div>
        </div>} */}

        {/* <Footer list1={moneys?.[0]?.list} list2={moneys?.[2]?.list}/> */}
        </div>
        <KeFu />

    </div>
}